'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames'));
var reactRouterDom = require('react-router-dom');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Avatar = function Avatar(_ref) {
  var children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["children", "className", "size"]);

  var classes = classNames('avatar', _defineProperty({}, "avatar--".concat(size), size), className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: "avatar__inner"
  }, React__default.Children.toArray(children).map(function (child, index) {
    if (typeof child === 'string') {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "avatar__text",
        key: index
      }, child);
    }

    return child;
  })));
};

Avatar.displayName = "Avatar";
Avatar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['S', 'M', 'L'])
};
Avatar.defaultProps = {
  size: 'M'
};

var Badge = function Badge(_ref) {
  var _classNames;

  var Tag = _ref.as,
      children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["as", "children", "className", "size", "theme"]);

  var classes = classNames('badge', (_classNames = {}, _defineProperty(_classNames, "badge--".concat(size), size), _defineProperty(_classNames, "badge--".concat(theme), theme), _classNames), className);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, rest), children);
};

Badge.displayName = "Badge";
Badge.propTypes = {
  as: PropTypes.oneOf(['div', 'span']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL']),
  theme: PropTypes.oneOf(['black', 'blue', 'green', 'grey', 'moss', 'navy', 'purple', 'red', 'teal', 'yellow'])
};
Badge.defaultProps = {
  as: 'div',
  size: 'M',
  theme: 'grey'
};

var Banner = function Banner(_ref) {
  var _classNames;

  var appearance = _ref.appearance,
      children = _ref.children,
      className = _ref.className,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["appearance", "children", "className", "theme"]);

  var classes = classNames('banner', (_classNames = {}, _defineProperty(_classNames, "banner--".concat(appearance), appearance), _defineProperty(_classNames, "banner--".concat(theme), theme), _classNames), className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, rest), children);
};

Banner.displayName = "Banner";
Banner.propTypes = {
  appearance: PropTypes.oneOf(['solid']),
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['green', 'red', 'yellow', 'blue'])
};
Banner.defaultProps = {
  appearance: 'solid',
  theme: 'green'
};

var Blockquote = function Blockquote(_ref) {
  var _classNames;

  var appearance = _ref.appearance,
      children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["appearance", "children", "className", "size", "theme"]);

  var classes = classNames('blockquote', (_classNames = {}, _defineProperty(_classNames, "blockquote--".concat(appearance), appearance), _defineProperty(_classNames, "blockquote--".concat(size), size), _defineProperty(_classNames, "blockquote--".concat(theme), theme), _classNames), className);
  return /*#__PURE__*/React__default.createElement("blockquote", _extends({
    className: classes
  }, rest), children);
};

Blockquote.displayName = "Blockquote";
Blockquote.propTypes = {
  appearance: PropTypes.oneOf(['outline', 'pipe', 'solid']),
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL']),
  theme: PropTypes.oneOf(['green', 'navy', 'red'])
};
Blockquote.defaultProps = {
  appearance: 'pipe',
  size: 'M',
  theme: 'green'
};

var Box = function Box(_ref) {
  var children = _ref.children,
      className = _ref.className,
      cover = _ref.cover,
      Tag = _ref.element,
      hover = _ref.hover,
      shadow = _ref.shadow,
      rest = _objectWithoutProperties(_ref, ["children", "className", "cover", "element", "hover", "shadow"]);

  var classes = classNames('box', {
    'box--cover': cover,
    'box--hover': hover,
    'box--shadow': shadow
  }, className);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, rest), children);
};

Box.displayName = "Box";
Box.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,

  /** Deprecated */
  cover: PropTypes.bool,
  element: PropTypes.oneOf(['div', 'article', 'aside']),
  hover: PropTypes.bool,
  shadow: PropTypes.bool
};
Box.defaultProps = {
  element: 'div'
};

var Breadcrumb = function Breadcrumb(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default.createElement("ul", _extends({
    className: classNames('breadcrumb', className)
  }, rest), children);
};

Breadcrumb.displayName = "Breadcrumb";
Breadcrumb.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var Tag = _ref.as,
      children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      to = _ref.to,
      rest = _objectWithoutProperties(_ref, ["as", "children", "className", "href", "to"]);

  var isLink = !!to || !!href;
  return /*#__PURE__*/React__default.createElement("li", _extends({
    className: classNames('breadcrumb__item', className)
  }, rest), isLink ? /*#__PURE__*/React__default.createElement(Tag, {
    className: "link",
    href: href,
    to: to
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "link__text"
  }, children)) : children);
};

BreadcrumbItem.displayName = "BreadcrumbItem";
BreadcrumbItem.propTypes = {
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.oneOf(['a'])]),
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
BreadcrumbItem.defaultProps = {
  as: 'a'
};

var Button = function Button(_ref) {
  var _classNames;

  var align = _ref.align,
      block = _ref.block,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      cover = _ref.cover,
      flat = _ref.flat,
      height = _ref.height,
      hideText = _ref.hideText,
      href = _ref.href,
      inverse = _ref.inverse,
      loaded = _ref.loaded,
      rel = _ref.rel,
      size = _ref.size,
      target = _ref.target,
      textColor = _ref.textColor,
      to = _ref.to,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["align", "block", "children", "className", "color", "cover", "flat", "height", "hideText", "href", "inverse", "loaded", "rel", "size", "target", "textColor", "to", "type"]);

  var classes = classNames('button', (_classNames = {}, _defineProperty(_classNames, "button--".concat(align), align), _defineProperty(_classNames, 'button--cover', cover), _defineProperty(_classNames, "button--".concat(color), color), _defineProperty(_classNames, "button--".concat(size), size), _defineProperty(_classNames, "button--height-".concat(height), height), _defineProperty(_classNames, 'button--hide-text', hideText), _defineProperty(_classNames, 'button--inverse', inverse), _defineProperty(_classNames, 'width-full', block), _defineProperty(_classNames, 'button--flat', flat), _defineProperty(_classNames, 'button--loading', loaded === 'LOADING'), _defineProperty(_classNames, 'button--success', loaded === 'SUCCESS'), _defineProperty(_classNames, 'button--failed', loaded === 'FAILED'), _classNames), className);
  var textClasses = classNames('button__text', _defineProperty({}, "color-".concat(textColor), textColor));
  var Tag = href ? 'a' : to ? reactRouterDom.Link : 'button';
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes,
    href: href,
    rel: rel || target === '_blank' ? 'noopener noreferrer' : null,
    target: target,
    to: to,
    type: href || to ? null : type
  }, rest), React__default.Children.toArray(children).map(function (child, index) {
    if (typeof child === 'string') {
      return /*#__PURE__*/React__default.createElement("span", {
        className: textClasses,
        key: index
      }, child);
    }

    if (child.type && child.type.displayName && child.type.displayName.includes('Icon') && React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "button__icon",
        key: index
      }, child);
    }

    return child;
  }));
};

Button.displayName = "Button";
Button.propTypes = {
  align: PropTypes.oneOf(['left', 'right', 'split-left', 'split-right', 'spread']),
  block: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(['green', 'red', 'grey', 'navy', 'yellow', 'blue', 'white']),
  cover: PropTypes.bool,
  download: PropTypes.bool,
  flat: PropTypes.bool,
  height: PropTypes.oneOf(['auto', 'short', 'tall']),
  hideText: PropTypes.bool,
  href: PropTypes.string,
  inverse: PropTypes.bool,
  loaded: PropTypes.oneOf(['LOADING', 'SUCCESS', 'FAILED']),
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  rel: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large']),
  target: PropTypes.oneOf(['_blank', '_self']),
  textColor: PropTypes.oneOf(['white', 'black']),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
};
Button.defaultProps = {
  color: 'green',
  type: 'button'
};

var ButtonSignIn = function ButtonSignIn(_ref) {
  var children = _ref.children,
      className = _ref.className,
      darkTheme = _ref.darkTheme,
      hideText = _ref.hideText,
      rest = _objectWithoutProperties(_ref, ["children", "className", "darkTheme", "hideText"]);

  var classes = classNames('button-sign-in', {
    'button-sign-in--dark': darkTheme
  }, className);
  var textClasses = classNames('button-sign-in__text', {
    'visually-hidden': hideText
  });
  return /*#__PURE__*/React__default.createElement("button", _extends({
    className: classes,
    type: "button"
  }, rest), React__default.Children.toArray(children).map(function (child, index) {
    if (typeof child === 'string') {
      return /*#__PURE__*/React__default.createElement("span", {
        className: textClasses,
        key: index
      }, child);
    }

    if (child.type && child.type.displayName && child.type.displayName.includes('Logo') && React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "button-sign-in__icon",
        key: index
      }, child);
    }

    return child;
  }));
};

ButtonSignIn.displayName = "ButtonSignIn";
ButtonSignIn.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  darkTheme: PropTypes.bool,
  hideText: PropTypes.bool
};

var Label = function Label(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      legend = _ref.legend,
      spaceTop = _ref.spaceTop,
      rest = _objectWithoutProperties(_ref, ["children", "className", "legend", "spaceTop"]);

  var classes = classNames('label', (_classNames = {}, _defineProperty(_classNames, "label--space-top-".concat(spaceTop), spaceTop), _defineProperty(_classNames, 'text-large', legend), _classNames), className);
  return /*#__PURE__*/React__default.createElement("label", _extends({
    className: classes
  }, rest), /*#__PURE__*/React__default.createElement("span", {
    className: "label__text"
  }, children));
};

Label.displayName = "Label";
Label.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  legend: PropTypes.bool,
  // If we require additional sizes this should be replaced with 'size' to maintain consistency with how we do it in other components.
  spaceTop: PropTypes.oneOf(['default', 'small', 'medium', 'large'])
};

var LabelCaption = function LabelCaption(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var classes = classNames('label__caption', className);
  return /*#__PURE__*/React__default.createElement("span", _extends({
    className: classes
  }, rest), children);
};

LabelCaption.displayName = "LabelCaption";
LabelCaption.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

var Checkbox = function Checkbox(_ref) {
  var box = _ref.box,
      children = _ref.children,
      className = _ref.className,
      flat = _ref.flat,
      id = _ref.id,
      label = _ref.label,
      labelClassName = _ref.labelClassName,
      validity = _ref.validity,
      rest = _objectWithoutProperties(_ref, ["box", "children", "className", "flat", "id", "label", "labelClassName", "validity"]);

  var containerClasses = classNames('checkbox-container', {
    'checkbox-container--box': box
  }, className);
  var checkboxClasses = classNames('checkbox', {
    'checkbox--flat': flat
  });
  var labelClasses = labelClassName; // Deprecated

  return /*#__PURE__*/React__default.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    "aria-invalid": validity === 'invalid' ? true : null,
    className: checkboxClasses,
    id: id,
    type: "checkbox"
  }, rest)), children, label && /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: id,
    className: labelClasses
  }, label));
};

Checkbox.displayName = "Checkbox";
Checkbox.propTypes = {
  box: PropTypes.bool,
  children: PropTypes.node,
  // This will be required once we deprecate label
  className: PropTypes.string,
  flat: PropTypes.bool,
  id: PropTypes.string.isRequired,

  /** Deprecated */
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),

  /** Deprecated */
  labelClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  validity: PropTypes.oneOf(['valid', 'invalid'])
};

var CheckboxGroup = function CheckboxGroup(_ref) {
  var children = _ref.children;

  function handleChange(e, field, form) {
    var dependents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var target = e.target;
    var value = target.value,
        checked = target.checked;
    var name = field.name;
    var values = form.values,
        setFieldValue = form.setFieldValue;
    var fieldValues = values[name]; // Decide whether this is a bit too Formik-specific?
    // Maybe it could be more abstract?

    if (checked) {
      setFieldValue(name, [].concat(_toConsumableArray(fieldValues), [value]));
    } else {
      var updatedValues = fieldValues.filter(function (v) {
        return v !== value && !dependents.includes(v);
      } // filtering out "nested" dependents TBC
      );
      setFieldValue(name, updatedValues);
    }
  }

  return children({
    handleChange: handleChange
  });
};

CheckboxGroup.propTypes = {
  children: PropTypes.func.isRequired
};

var Code = function Code(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var classes = classNames('code', className);
  return /*#__PURE__*/React__default.createElement("code", _extends({
    className: classes
  }, rest), children);
};

Code.displayName = "Code";
Code.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var DescriptionList = function DescriptionList(_ref) {
  var border = _ref.border,
      children = _ref.children,
      className = _ref.className,
      space = _ref.space,
      rest = _objectWithoutProperties(_ref, ["border", "children", "className", "space"]);

  var classes = classNames('dl', _defineProperty({
    'dl--border': border
  }, "dl--space-".concat(space), space), className);
  return /*#__PURE__*/React__default.createElement("dl", _extends({
    className: classes
  }, rest), children);
};

DescriptionList.displayName = "DescriptionList";
DescriptionList.propTypes = {
  border: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  space: PropTypes.oneOf(['none', 'S', 'L'])
};

var DescriptionTerm = function DescriptionTerm(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React__default.createElement("dt", rest, children);
};

DescriptionTerm.displayName = "DescriptionTerm";
DescriptionTerm.propTypes = {
  children: PropTypes.node.isRequired
};

var DescriptionDetails = function DescriptionDetails(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React__default.createElement("dd", rest, children);
};

DescriptionDetails.displayName = "DescriptionDetails";
DescriptionDetails.propTypes = {
  children: PropTypes.node.isRequired
};

var Details = function Details(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var classes = classNames('details', className);
  return /*#__PURE__*/React__default.createElement("details", _extends({
    className: classes
  }, rest), children);
};

Details.displayName = "Details";
Details.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var Fieldset = function Fieldset(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      hideLegend = _ref.hideLegend,
      legend = _ref.legend,
      name = _ref.name,
      size = _ref.size,
      spaceTopSmall = _ref.spaceTopSmall,
      spaceTopLarge = _ref.spaceTopLarge,
      rest = _objectWithoutProperties(_ref, ["children", "className", "hideLegend", "legend", "name", "size", "spaceTopSmall", "spaceTopLarge"]);

  var fieldsetClasses = classNames('fieldset', className);
  var legendClasses = classNames('fieldset__legend', (_classNames = {
    'visually-hidden': hideLegend
  }, _defineProperty(_classNames, "fieldset__legend--space-top-S-".concat(spaceTopSmall), spaceTopSmall), _defineProperty(_classNames, "fieldset__legend--space-top-L-".concat(spaceTopLarge), spaceTopLarge), _defineProperty(_classNames, "text-".concat(size), size), _classNames));
  return /*#__PURE__*/React__default.createElement("fieldset", _extends({
    className: fieldsetClasses,
    name: name
  }, rest), /*#__PURE__*/React__default.createElement("legend", {
    className: legendClasses
  }, legend), children);
};

Fieldset.displayName = "Fieldset";
Fieldset.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  hideLegend: PropTypes.bool,
  legend: PropTypes.string.isRequired,
  name: PropTypes.string,
  size: PropTypes.oneOf(['xsmall', 'small']),
  spaceTopSmall: PropTypes.oneOf(['default', 'small', 'medium', 'large']),
  spaceTopLarge: PropTypes.oneOf(['default', 'small', 'medium', 'large'])
};

var Grid = function Grid(_ref) {
  var _classNames;

  var align = _ref.align,
      auto = _ref.auto,
      children = _ref.children,
      className = _ref.className,
      Tag = _ref.element,
      gutters = _ref.gutters,
      guttersVertical = _ref.guttersVertical,
      justify = _ref.justify,
      noWrap = _ref.noWrap,
      reverse = _ref.reverse,
      rest = _objectWithoutProperties(_ref, ["align", "auto", "children", "className", "element", "gutters", "guttersVertical", "justify", "noWrap", "reverse"]);

  var classes = classNames('grid', (_classNames = {}, _defineProperty(_classNames, "grid--".concat(justify), justify), _defineProperty(_classNames, "grid--".concat(align), align), _defineProperty(_classNames, 'grid--auto', auto), _defineProperty(_classNames, 'grid--reverse', reverse), _defineProperty(_classNames, 'grid--no-wrap', noWrap), _defineProperty(_classNames, "grid--gutters-".concat(gutters), gutters), _defineProperty(_classNames, 'grid--gutters-vertical', guttersVertical), _classNames), className);
  var isList = Tag === 'ul' || Tag === 'ol';
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, rest), React__default.Children.toArray(children).map(function (child, index) {
    if (isList) {
      return React__default.cloneElement(child, {
        element: 'li',
        key: index
      });
    }

    return child;
  }));
};

Grid.displayName = "Grid";
Grid.propTypes = {
  align: PropTypes.oneOf(['top', 'middle', 'bottom']),
  auto: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  element: PropTypes.oneOf(['div', 'ul', 'ol']),
  gutters: PropTypes.oneOf(['none', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL']),
  guttersVertical: PropTypes.bool,
  justify: PropTypes.oneOf(['left', 'center', 'right', 'spread']),
  noWrap: PropTypes.bool,
  reverse: PropTypes.bool
};
Grid.defaultProps = {
  element: 'div'
};

/**
 * Return responsive classnames from props object (e.g. { default: '1-2', medium: '1-4' })
 * @param {object} widths Props object containing width definitions
 * @param {string} prefix Prefix to prepend to each classname defined (default: 'width-'). Can be used for 'push-' or 'pull-'.
 * @returns {Array} Array of className strings (e.g. ['width-1-2', 'width-1-4-medium'])
 */
var getGridClassesFromPropObject = function getGridClassesFromPropObject() {
  var widths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'width-';
  var widthClassesArray = Object.keys(widths).map(function (breakpoint) {
    var suffix = breakpoint !== 'default' ? "-".concat(breakpoint) : ''; // add responsive suffix, unless 'default'

    return "".concat(prefix).concat(widths[breakpoint]).concat(suffix);
  });
  return _toConsumableArray(widthClassesArray);
};
/**
 * 12-column grid denominations for cell and push classnames
 */

var gridDenominations = ['auto', '1-12', '1-6', '1-4', '1-3', '5-12', '1-2', '7-12', '2-3', '3-4', '5-6', '11-12', 'full'];

var GridCell = function GridCell(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Tag = _ref.element,
      push = _ref.push,
      split = _ref.split,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["children", "className", "element", "push", "split", "width"]);

  var classes = classNames('grid__cell', {
    'grid__cell--split': split
  }, getGridClassesFromPropObject(width, 'grid__cell--'), getGridClassesFromPropObject(push, 'grid__cell--push-'), className);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, rest), children);
};

GridCell.displayName = "GridCell";
GridCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  element: PropTypes.oneOf(['div', 'li']),
  push: PropTypes.shape({
    default: PropTypes.oneOf(gridDenominations),
    small: PropTypes.oneOf(gridDenominations),
    medium: PropTypes.oneOf(gridDenominations)
  }),
  split: PropTypes.bool,
  width: PropTypes.shape({
    default: PropTypes.oneOf(gridDenominations),
    small: PropTypes.oneOf(gridDenominations),
    medium: PropTypes.oneOf(gridDenominations)
  })
};
GridCell.defaultProps = {
  element: 'div',
  push: {},
  width: {}
};

var Header = function Header(_ref) {
  var _classNames;

  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      guttersX = _ref.guttersX,
      guttersY = _ref.guttersY,
      height = _ref.height,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["align", "children", "className", "guttersX", "guttersY", "height", "width"]);

  var classes = classNames('header', className);
  var innerClasses = classNames('header__inner', (_classNames = {}, _defineProperty(_classNames, "header__inner--".concat(align), align), _defineProperty(_classNames, "header__inner--gutters-x-".concat(guttersX), guttersX), _defineProperty(_classNames, "header__inner--gutters-y-".concat(guttersY), guttersY), _defineProperty(_classNames, "header__inner--height-".concat(height), height), _defineProperty(_classNames, "header__inner--width-".concat(width), width), _classNames));
  return /*#__PURE__*/React__default.createElement("header", _extends({
    className: classes
  }, rest, {
    role: "banner"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: innerClasses
  }, children));
};

Header.displayName = "Header";
Header.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.node,
  className: PropTypes.string,
  guttersX: PropTypes.oneOf(['none', 'S', 'M', 'L', 'XL']),
  guttersY: PropTypes.oneOf(['none', 'S', 'M', 'L', 'XL']),
  height: PropTypes.oneOf(['100', '200', '300', '400']),
  width: PropTypes.oneOf(['600', '800', '1000', '1200', '1540'])
};
Header.defaultProps = {
  align: 'center',
  guttersX: 'L',
  guttersY: 'L',
  height: '300',
  width: '1540'
};

var Heading = function Heading(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      display = _ref.display,
      level = _ref.level;
  var Tag = "h".concat(level);
  var classes = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(Tag), !display), _defineProperty(_classNames, "".concat(display), display), _classNames), className);
  return /*#__PURE__*/React__default.createElement(Tag, {
    className: classes
  }, children);
};

Heading.displayName = "Heading";
Heading.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  display: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6])
};
Heading.defaultProps = {
  level: 2
};

var Hr = function Hr(_ref) {
  var _classNames;

  var className = _ref.className,
      size = _ref.size,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["className", "size", "theme"]);

  var classes = classNames('hr', (_classNames = {}, _defineProperty(_classNames, "hr--".concat(size), size), _defineProperty(_classNames, "hr--".concat(theme), theme), _classNames), className);
  return /*#__PURE__*/React__default.createElement("hr", _extends({
    className: classes
  }, rest));
};

Hr.displayName = "Hr";
Hr.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['S', 'M', 'L']),
  theme: PropTypes.oneOf(['blue', 'green', 'grey', 'moss', 'navy', 'purple', 'red', 'teal', 'yellow'])
};
Hr.defaultProps = {
  size: 'S',
  theme: 'grey'
};

var Indicator = function Indicator(_ref) {
  var _classNames;

  var Tag = _ref.as,
      className = _ref.className,
      pulse = _ref.pulse,
      shape = _ref.shape,
      size = _ref.size,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["as", "className", "pulse", "shape", "size", "theme"]);

  var classes = classNames('indicator', (_classNames = {}, _defineProperty(_classNames, "indicator--pulse", pulse), _defineProperty(_classNames, "indicator--".concat(shape), shape), _defineProperty(_classNames, "indicator--".concat(size), size), _defineProperty(_classNames, "indicator--".concat(theme), theme), _classNames), className);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, rest));
};

Indicator.displayName = "Indicator";
Indicator.propTypes = {
  as: PropTypes.oneOf(['div', 'span']),
  className: PropTypes.string,
  pulse: PropTypes.bool,
  shape: PropTypes.oneOf(['circle', 'square', 'triangle-down', 'triangle-up']),
  size: PropTypes.oneOf(['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL']),
  theme: PropTypes.oneOf(['blue', 'green', 'grey', 'moss', 'navy', 'purple', 'red', 'teal', 'yellow'])
};
Indicator.defaultProps = {
  as: 'div',
  shape: 'circle',
  size: 'M',
  theme: 'grey'
};

var List = function List(_ref) {
  var children = _ref.children,
      className = _ref.className,
      flat = _ref.flat,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["children", "className", "flat", "type"]);

  var Tag = type === 'numbered' ? 'ol' : 'ul';
  var classes = classNames(Tag, _defineProperty({}, "".concat(Tag, "--flat"), flat), className);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, rest), children);
};

List.displayName = "List";
List.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  flat: PropTypes.bool,
  type: PropTypes.oneOf(['bullet', 'numbered'])
};
List.defaultProps = {
  type: 'bullet'
};

var ListItem = function ListItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default.createElement("li", _extends({
    className: className
  }, rest), children);
};

ListItem.displayName = "ListItem";
ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

var Loader = function Loader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Component = _ref.component,
      isLoading = _ref.isLoading,
      loaded = _ref.loaded,
      overlayColor = _ref.overlayColor,
      type = _ref.type;
  var styles = {
    '--overlay-color': overlayColor
  };
  return /*#__PURE__*/React__default.createElement(Component, {
    className: classNames('loader', _defineProperty({
      'loader--loading': loaded === 'LOADING' || isLoading
    }, "loader--".concat(type), type), className),
    style: styles
  }, children);
};

Loader.displayName = "Loader";
Loader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.oneOf(['div', 'section'])]),
  isLoading: PropTypes.bool,

  /** Deprecated */
  loaded: PropTypes.oneOf(['LOADING', 'SUCCESS', 'FAILED']),
  overlayColor: PropTypes.string,
  type: PropTypes.oneOf(['component', 'fill', 'screen'])
};
Loader.defaultProps = {
  component: 'div',
  overlayColor: 'hsla(var(--color-white-hsl), 0.8)',
  type: 'component'
};

var LogoGoogle = function LogoGoogle(_ref) {
  var className = _ref.className,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true",
    className: className,
    focusable: "false",
    viewBox: "0 0 48 48",
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("title", null, "Google"), /*#__PURE__*/React__default.createElement("path", {
    fill: "#EA4335",
    d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#4285F4",
    d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#FBBC05",
    d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#34A853",
    d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
  }));
};

LogoGoogle.displayName = "LogoGoogle";
LogoGoogle.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};
LogoGoogle.defaultProps = {
  width: '18',
  height: '18'
};
LogoGoogle.displayName = 'LogoGoogle';

var LogoSoftIron = function LogoSoftIron(_ref) {
  var className = _ref.className,
      height = _ref.height,
      theme = _ref.theme,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["className", "height", "theme", "width"]);

  var classes = classNames('logo-softiron', _defineProperty({}, "logo-softiron--".concat(theme), theme), className);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    "aria-hidden": "true",
    className: classes,
    focusable: "false",
    height: height,
    viewBox: "0 0 230.8 50.4",
    width: width,
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React__default.createElement("g", {
    className: "secondary",
    fill: "#0c314f"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M62.5,31.9c0.1,1.3,0.9,2.3,2.9,2.3c1.5,0,2.9-0.6,2.9-2.1c0-0.4,0-1.1-2.3-1.9l-2.7-0.9 c-5.2-1.4-6.1-4.7-6.1-6.9c0-4.3,3.5-7.1,8.2-7.1c4.6,0,8,2.7,8,7.3h-5.7c0-1.3-0.7-2.2-2.4-2.2c-1.5,0-2.5,0.7-2.5,1.9 c0,0.4,0.1,1.3,2.2,1.9l2.7,0.8c6.1,1.9,6.5,5.4,6.5,7.1c0,5.1-4.7,7.1-8.6,7.1c-5.2,0-8.6-2.8-8.6-7.2H62.5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M90.1,15.2c6.6,0,11.9,5.4,11.9,12c0,6.6-5.3,11.9-11.9,11.9c-6.6,0-11.9-5.4-11.9-11.9 C78.3,20.6,83.6,15.2,90.1,15.2z M90.1,33.5c3.5,0,6.2-2.8,6.2-6.3c0-3.5-2.8-6.3-6.2-6.3c-3.5,0-6.2,2.8-6.2,6.3 C84,30.7,86.7,33.5,90.1,33.5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M107.6,38.9V15.5h15.5l-1.3,4.9h-8.5v4.5h7.3l-1.3,4.9h-6v9H107.6z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M126.7,20.5l1.3-4.9h16.4v4.9h-6v18.4h-5.7V20.5H126.7z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M29.9,20l-1.6,1.7c0,0,2.6,2.4,3.9,5l-1.6,1.5l1.2,2.4c0,0,0.7-0.5,1.5-1.3c0.2-0.2,0.7-0.6,1.2-1.2 c0,0,0,0,0-0.1c0,0,0,0,0,0c1.2-1.3,2.7-3.6,3.1-6.6c0,0-0.3-1.2-1.6-2.6c-1,1.3-1.7,1.9-1.7,1.9s-1.7-2.5-4.2-4.4 c-0.6,0.6-2,2-2,2L29.9,20z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17,30.4l1.6-1.7c0,0-2.6-2.4-3.9-5l1.6-1.5l-1.2-2.4c0,0-0.7,0.5-1.5,1.3c-0.2,0.2-0.7,0.6-1.2,1.2 c0,0,0,0,0,0.1c0,0,0,0,0,0C11.1,23.7,9.5,26,9.2,29c0,0,0.3,1.2,1.6,2.6c1-1.3,1.7-1.9,1.7-1.9s1.7,2.5,4.2,4.4c0.6-0.6,2-2,2-2 L17,30.4z"
  })), /*#__PURE__*/React__default.createElement("g", {
    className: "primary",
    fill: "#28a730"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M149,15.5h5.7v23.3H149V15.5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M161.6,38.9V15.5h9.6c5.5,0,8,3.9,8,7.8c0,3.3-1.8,6.5-5.6,7.5l5.7,8.1h-6.6l-5-7.8h-0.5v7.8H161.6z M167.2,20.5v5.7h3.7c1.9,0,2.5-1.5,2.5-2.9s-0.7-2.8-2.5-2.8H167.2z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M230.8,15.5v23.3h-4.9l-7.1-12.7v12.7H213V15.5h5.1l7,12.6V15.5H230.8z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M195.5,15.2c6.6,0,11.9,5.4,11.9,12c0,6.6-5.3,11.9-11.9,11.9c-6.6,0-11.9-5.4-11.9-11.9 C183.7,20.6,189,15.2,195.5,15.2z M195.5,33.5c3.5,0,6.2-2.8,6.2-6.3c0-3.5-2.8-6.3-6.2-6.3c-3.5,0-6.2,2.8-6.2,6.3 C189.4,30.7,192.1,33.5,195.5,33.5z"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    points: "2.5,47.4 5.7,47.6 5.4,44.4 2.1,44.3"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    points: "0.4,49.5 2.8,49.7 2.5,47.4 0,47.2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.7,47.6l-3-0.1l0.3,2.6l2.8,0.1L8.7,47.6l3,0l0.1,2.7l3-0.1l-0.1-2.5l2.8-0.2l3.8-0.3L21.1,44l3.3-0.3 l0.2,3.2l-3.2,0.4l0.1,2.8c0,0,7.6,0.2,12.8-5.8c6.1-7,4.7-20.5,4.7-20.5s-1.8,7.9-10.7,10.3c-1.3,0.4-3.8,1.1-3.8,1.1L20.5,36 l0.3,3.6c0,0-2.7,0.4-3.7,0.4l-0.3-3.4c0,0-4.6,0.4-8.8,0.3l0.3,3.9l-3.2-0.1l0.3,3.7l3.1,0L8.7,47.6z"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    points: "44.4,3 41.2,2.8 41.5,6 44.7,6.1"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    points: "46.5,0.9 44.1,0.7 44.4,3 46.9,3.2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M38.2,2.8l3,0.1l-0.3-2.6l-2.8-0.1L38.2,2.8l-3,0L35.1,0l-3,0.1l0.1,2.5l-2.8,0.2l-3.8,0.3l0.2,3.3l-3.3,0.3 l-0.2-3.2l3.2-0.4l-0.1-2.8c0,0-7.6-0.2-12.8,5.8c-6.1,7-4.7,20.5-4.7,20.5s1.8-7.9,10.7-10.3c1.3-0.4,3.8-1.1,3.8-1.1l3.9-0.7 l-0.3-3.6c0,0,2.7-0.4,3.7-0.4l0.3,3.4c0,0,4.6-0.4,8.8-0.3l-0.3-3.9l3.2,0.1L41.5,6l-3.1,0L38.2,2.8z"
  })));
};

LogoSoftIron.displayName = "LogoSoftIron";
LogoSoftIron.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.oneOf(['black', 'green', 'navy', 'navyGreen', 'white', 'whiteGreen']),
  width: PropTypes.string
};
LogoSoftIron.defaultProps = {
  height: '50',
  theme: 'navyGreen',
  width: '230'
};
LogoSoftIron.displayName = 'LogoSoftIron';

var MediaWrap = function MediaWrap(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      fit = _ref.fit,
      ratio = _ref.ratio;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('media-wrap', (_classNames = {}, _defineProperty(_classNames, "media-wrap--".concat(ratio), ratio), _defineProperty(_classNames, "media-wrap--".concat(fit), fit), _classNames), className)
  }, React__default.Children.toArray(children).map(function (child, index) {
    return React__default.cloneElement(child, {
      className: classNames('media-wrap__item', child.props.className),
      key: index
    });
  }));
};

MediaWrap.displayName = "MediaWrap";
MediaWrap.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  fit: PropTypes.oneOf(['cover', 'contain']),
  ratio: PropTypes.oneOf(['2x3', '3x4', '1x1', '3x2', '16x9', '4x1'])
};
MediaWrap.defaultProps = {
  fit: 'cover',
  ratio: '16x9'
};

var NavigationPrimary = function NavigationPrimary(_ref) {
  var children = _ref.children,
      className = _ref.className,
      NavLink = _ref.link,
      _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? [] : _ref$routes,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["children", "className", "link", "routes", "theme"]);

  var classes = classNames('navigation-primary', _defineProperty({}, "navigation-primary--".concat(theme), theme), className);
  return /*#__PURE__*/React__default.createElement("nav", _extends({
    className: classes
  }, rest), /*#__PURE__*/React__default.createElement("ul", {
    className: "navigation-primary__items"
  }, routes.filter(function (route) {
    return !route.excludeFromNav;
  }).map(function (route, i) {
    var Icon = route.icon; // does current route include child `routes` items which aren't `excludeFromNav`?

    var hasRenderableChildren = route.routes ? route.routes.filter(function (childRoute) {
      return !childRoute.excludeFromNav;
    }).length : false;
    return /*#__PURE__*/React__default.createElement("li", {
      key: "item-".concat(i),
      className: "navigation-primary__item"
    }, /*#__PURE__*/React__default.createElement(NavLink, {
      to: route.path,
      exact: route.exact,
      className: "navigation-primary__link",
      activeClassName: "is-active"
    }, Icon && /*#__PURE__*/React__default.createElement("span", {
      className: "navigation-primary__link-icon"
    }, /*#__PURE__*/React__default.createElement(Icon, null)), /*#__PURE__*/React__default.createElement("span", {
      className: "navigation-primary__link-text"
    }, route.title)), route.routes && route.routes.length && hasRenderableChildren ? /*#__PURE__*/React__default.createElement("ul", {
      className: "navigation-primary__sub-items"
    }, route.routes.filter(function (route) {
      return !route.excludeFromNav;
    }).map(function (route, i) {
      return /*#__PURE__*/React__default.createElement("li", {
        key: "sub-item-".concat(i),
        className: "navigation-primary__sub-item"
      }, /*#__PURE__*/React__default.createElement(NavLink, {
        to: route.path,
        exact: route.exact,
        className: "navigation-primary__sub-link",
        activeClassName: "is-active"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "navigation-primary__sub-link-text"
      }, route.title)));
    })) : null);
  })));
};

NavigationPrimary.displayName = "NavigationPrimary";
NavigationPrimary.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  link: PropTypes.elementType.isRequired,
  routes: PropTypes.array,
  theme: PropTypes.oneOf(['dark', 'light'])
};
NavigationPrimary.defaultProps = {
  theme: 'dark'
};

var NavigationProgress = function NavigationProgress(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      current = _ref.current,
      enabled = _ref.enabled,
      locked = _ref.locked,
      _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? [] : _ref$routes,
      rest = _objectWithoutProperties(_ref, ["appearance", "className", "current", "enabled", "locked", "routes"]);

  var containerClasses = classNames('navigation-progress-container', _defineProperty({
    'navigation-progress-container--complete': enabled === routes.length - 1
  }, "navigation-progress-container--".concat(appearance), appearance), className);

  function isIncludedInNav(route) {
    return !route.excludeFromNav;
  }

  var NavigationProgressItem = function NavigationProgressItem(route, index) {
    var path = route.path,
        Icon = route.icon,
        title = route.title;
    var isCurrent = index === current;
    var isDisabled = index > enabled;
    var isLocked = Array.isArray(locked) ? locked.includes(index) : locked === index;
    var Tag = isDisabled || isLocked ? 'span' : reactRouterDom.Link;
    var linkClasses = classNames('navigation-progress__link', {
      'navigation-progress__link--disabled': isDisabled,
      'navigation-progress__link--locked': isLocked
    });
    return /*#__PURE__*/React__default.createElement("li", {
      className: "navigation-progress__item",
      key: index
    }, /*#__PURE__*/React__default.createElement(Tag, {
      "aria-current": isCurrent ? 'page' : null,
      className: linkClasses,
      to: isDisabled || isLocked ? null : path
    }, Icon && /*#__PURE__*/React__default.createElement("span", {
      className: "navigation-progress__link-icon"
    }, /*#__PURE__*/React__default.createElement(Icon, null)), /*#__PURE__*/React__default.createElement("span", {
      className: "navigation-progress__link-text"
    }, title)));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React__default.createElement("nav", _extends({
    className: "navigation-progress"
  }, rest), /*#__PURE__*/React__default.createElement("ol", {
    className: "navigation-progress__items"
  }, routes.filter(isIncludedInNav).map(NavigationProgressItem))));
};

NavigationProgress.displayName = "NavigationProgress";
NavigationProgress.propTypes = {
  appearance: PropTypes.oneOf(['border', 'shadow']),
  className: PropTypes.string,
  current: PropTypes.number,
  enabled: PropTypes.number,
  locked: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
  routes: PropTypes.array
};
NavigationProgress.defaultProps = {
  appearance: 'shadow'
};

var OffCanvasWrap = function OffCanvasWrap(_ref) {
  var children = _ref.children,
      className = _ref.className,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["children", "className", "theme"]);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var classes = classNames('off-canvas-wrap', _defineProperty({
    'off-canvas-wrap--is-open': isOpen
  }, "off-canvas-wrap--".concat(theme), theme), className);
  var handleToggle = React.useCallback(function (event) {
    setIsOpen(function (isOpen) {
      return !isOpen;
    });
    event.preventDefault();
  }, []); // Handle keyboard bindings

  React.useEffect(function () {
    function handleKeydown(event) {
      if (event.keyCode === 27) setIsOpen(false);
    }

    if (!document) return;
    document.addEventListener('keydown', handleKeydown, false);
    return function () {
      document.removeEventListener('keydown', handleKeydown, false);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, rest), /*#__PURE__*/React__default.createElement("a", {
    "aria-label": "Open Off Canvas",
    className: "off-canvas-wrap__open",
    href: "#off-canvas",
    onClick: handleToggle
  }), /*#__PURE__*/React__default.createElement("div", {
    "aria-hidden": !isOpen ? 'true' : null,
    className: "off-canvas-wrap__inner",
    id: "off-canvas"
  }, /*#__PURE__*/React__default.createElement("a", {
    "aria-label": "Close Off Canvas",
    className: "off-canvas-wrap__close",
    href: "#",
    onClick: handleToggle
  }), children));
};

OffCanvasWrap.displayName = "OffCanvasWrap";
OffCanvasWrap.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['dark', 'light'])
};
OffCanvasWrap.defaultProps = {
  theme: 'dark'
};

var Overflow = function Overflow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var classes = classNames('overflow', className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, rest), children);
};

Overflow.displayName = "Overflow";
Overflow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var Paragraph = function Paragraph(_ref) {
  var _classNames;

  var align = _ref.align,
      casing = _ref.casing,
      children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      weight = _ref.weight;
  var classes = classNames('p', (_classNames = {}, _defineProperty(_classNames, "text-".concat(size), size), _defineProperty(_classNames, "text-".concat(weight), weight), _defineProperty(_classNames, "text-".concat(align), align), _defineProperty(_classNames, "text-".concat(casing), casing), _classNames), className);
  return /*#__PURE__*/React__default.createElement("p", {
    className: classes
  }, children);
};

Paragraph.displayName = "Paragraph";
Paragraph.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  casing: PropTypes.oneOf(['upper', 'capital']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge']),
  weight: PropTypes.oneOf(['normal', 'semibold', 'bold', 'heavy'])
};

var Pre = function Pre(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var classes = classNames('pre', className);
  return /*#__PURE__*/React__default.createElement("pre", _extends({
    className: classes
  }, rest), children);
};

Pre.displayName = "Pre";
Pre.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var Progress = function Progress(_ref) {
  var className = _ref.className,
      children = _ref.children,
      max = _ref.max,
      theme = _ref.theme,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["className", "children", "max", "theme", "value"]);

  var classes = classNames('progress', _defineProperty({}, "progress--".concat(theme), theme), className);
  return /*#__PURE__*/React__default.createElement("progress", _extends({
    className: classes,
    max: max,
    value: value
  }, rest), children);
};

Progress.displayName = "Progress";
Progress.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  max: PropTypes.number,
  theme: PropTypes.oneOf(['green', 'navy', 'red']),
  value: PropTypes.number
};
Progress.defaultProps = {
  max: 100,
  theme: 'green'
};

var Radio = function Radio(_ref) {
  var box = _ref.box,
      children = _ref.children,
      className = _ref.className,
      flat = _ref.flat,
      id = _ref.id,
      label = _ref.label,
      labelClassName = _ref.labelClassName,
      validity = _ref.validity,
      rest = _objectWithoutProperties(_ref, ["box", "children", "className", "flat", "id", "label", "labelClassName", "validity"]);

  var containerClasses = classNames('radio-container', {
    'radio-container--box': box
  }, className);
  var radioClasses = classNames('radio', {
    'radio--flat': flat
  });
  var labelClasses = labelClassName; // Deprecated

  return /*#__PURE__*/React__default.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    "aria-invalid": validity === 'invalid' ? true : null,
    className: radioClasses,
    id: id,
    type: "radio"
  }, rest)), children, label && /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: id,
    className: labelClasses
  }, label));
};

Radio.displayName = "Radio";
Radio.propTypes = {
  box: PropTypes.bool,
  children: PropTypes.node,
  // This will be required once we depreciate label
  className: PropTypes.string,
  flat: PropTypes.bool,
  id: PropTypes.string.isRequired,

  /** Deprecated */
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),

  /** Deprecated */
  labelClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  validity: PropTypes.oneOf(['valid', 'invalid'])
};

var Range = function Range(_ref) {
  var _classNames;

  var className = _ref.className,
      id = _ref.id,
      max = _ref.max,
      min = _ref.min,
      name = _ref.name,
      step = _ref.step,
      theme = _ref.theme,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["className", "id", "max", "min", "name", "step", "theme", "value"]);

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      isEnhanced = _useState2[0],
      setIsEnhanced = _useState2[1]; // Set enhanced class for Range on mount for JS-enhanced styling hook


  React.useEffect(function () {
    setIsEnhanced(true);
  }, []);
  var classes = classNames('range', (_classNames = {}, _defineProperty(_classNames, "range--".concat(theme), theme), _defineProperty(_classNames, 'range--enhanced', isEnhanced), _classNames), className);
  var styleProps = {
    '--min': min,
    '--max': max,
    '--val': value
  };
  return /*#__PURE__*/React__default.createElement("input", _extends({
    className: classes,
    id: id,
    max: max,
    min: min,
    name: name,
    step: step,
    style: isEnhanced ? styleProps : null,
    type: "range",
    value: value
  }, rest));
};

Range.displayName = "Range";
Range.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  step: PropTypes.number,
  theme: PropTypes.oneOf(['blue', 'green', 'grey', 'moss', 'navy', 'purple', 'red', 'teal', 'yellow']),
  value: PropTypes.number
};
Range.defaultProps = {
  max: 100,
  min: 0,
  theme: 'green'
};

var Section = function Section(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default.createElement("section", _extends({
    className: className
  }, rest), children);
};

Section.displayName = "Section";
Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var Select = function Select(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children,
      className = _ref.className,
      validity = _ref.validity,
      rest = _objectWithoutProperties(_ref, ["appearance", "children", "className", "validity"]);

  var classes = classNames('select', _defineProperty({}, "select--".concat(appearance), appearance), className);
  var validStates = {
    invalid: true,
    valid: false
  };
  return /*#__PURE__*/React__default.createElement("select", _extends({
    "aria-invalid": validStates[validity],
    className: classes
  }, rest), children);
};

Select.displayName = "Select";
Select.propTypes = {
  appearance: PropTypes.oneOf(['border', 'flat', 'shadow']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  validity: PropTypes.oneOf(['valid', 'invalid'])
};
Select.defaultProps = {
  appearance: 'border'
};

var Site = function Site(_ref) {
  var children = _ref.children,
      className = _ref.className,
      sidebar = _ref.sidebar,
      rest = _objectWithoutProperties(_ref, ["children", "className", "sidebar"]);

  var classes = classNames('site', {
    'site--sidebar': sidebar
  }, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    role: "document",
    className: classes
  }, rest), children);
};

Site.displayName = "Site";
Site.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  sidebar: PropTypes.bool
};

var SiteFooter = function SiteFooter(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default.createElement("footer", _extends({
    role: "contentinfo",
    className: classNames('site-footer', className)
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: "site-footer__inner"
  }, children));
};

SiteFooter.displayName = "SiteFooter";
SiteFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var SiteHeader = function SiteHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      sticky = _ref.sticky,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["children", "className", "sticky", "theme", "title"]);

  var themeLogo = {
    dark: 'whiteGreen',
    light: 'navyGreen'
  };
  return /*#__PURE__*/React__default.createElement("header", _extends({
    role: "banner",
    className: classNames('site-header', _defineProperty({}, "site-header--".concat(theme), theme))
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: classNames('site-header__inner', {
      'site-header__inner--sticky': sticky
    }, className)
  }, /*#__PURE__*/React__default.createElement(Grid, {
    align: "middle",
    guttersVertical: true,
    justify: "spread"
  }, /*#__PURE__*/React__default.createElement(GridCell, {
    className: "site-header__grid-cell"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex--bottom"
  }, /*#__PURE__*/React__default.createElement(reactRouterDom.Link, {
    className: "site-header__logo",
    to: "/"
  }, /*#__PURE__*/React__default.createElement(LogoSoftIron, {
    theme: themeLogo[theme]
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "visually-hidden"
  }, "SoftIron")), title && /*#__PURE__*/React__default.createElement("span", {
    className: "site-header__title"
  }, title))), children && /*#__PURE__*/React__default.createElement(GridCell, {
    className: "site-header__grid-cell"
  }, children))));
};

SiteHeader.displayName = "SiteHeader";
SiteHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  sticky: PropTypes.bool,
  theme: PropTypes.oneOf(['dark', 'light']),
  title: PropTypes.string
};
SiteHeader.defaultProps = {
  theme: 'dark'
};

var SiteMain = function SiteMain(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default.createElement("main", _extends({
    role: "main",
    className: classNames('site-main', className)
  }, rest), children);
};

SiteMain.displayName = "SiteMain";
SiteMain.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var Status = function Status(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      Tag = _ref.element,
      hideStatus = _ref.hideStatus,
      hideText = _ref.hideText,
      pulse = _ref.pulse,
      shape = _ref.shape,
      size = _ref.size,
      spaceLeft = _ref.spaceLeft,
      spaceRight = _ref.spaceRight,
      status = _ref.status,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["children", "className", "element", "hideStatus", "hideText", "pulse", "shape", "size", "spaceLeft", "spaceRight", "status", "theme"]);

  var classes = classNames('status', (_classNames = {}, _defineProperty(_classNames, "status--pulse", pulse), _defineProperty(_classNames, "status--".concat(shape), shape), _defineProperty(_classNames, "status--".concat(size), size), _defineProperty(_classNames, "ml-".concat(spaceLeft), spaceLeft), _defineProperty(_classNames, "mr-".concat(spaceRight), spaceRight), _defineProperty(_classNames, "status--".concat(theme), theme), _classNames), className);
  var textClasses = classNames('status__text', {
    'visually-hidden': hideStatus || hideText
  });
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, rest), status && /*#__PURE__*/React__default.createElement("span", {
    className: textClasses
  }, status), React__default.Children.toArray(children).map(function (child, index) {
    if (typeof child === 'string') {
      return /*#__PURE__*/React__default.createElement("span", {
        className: textClasses,
        key: index
      }, child);
    }

    if (child.type && child.type.displayName && child.type.displayName.includes('Icon') && React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "status__icon",
        key: index
      }, child);
    }

    return child;
  }));
};

Status.displayName = "Status";
Status.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  element: PropTypes.oneOf(['div', 'span']),
  hideStatus: PropTypes.bool,
  hideText: PropTypes.bool,
  pulse: PropTypes.bool,
  shape: PropTypes.oneOf(['circle', 'square', 'triangle-down', 'triangle-up']),
  size: PropTypes.oneOf(['XS', 'S', 'M', 'L']),
  spaceLeft: PropTypes.oneOf(['S', 'M', 'L']),
  spaceRight: PropTypes.oneOf(['S', 'M', 'L']),
  status: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  theme: PropTypes.oneOf(['blue', 'green', 'grey', 'moss', 'navy', 'purple', 'red', 'teal', 'yellow'])
};
Status.defaultProps = {
  element: 'div',
  shape: 'circle',
  size: 'M',
  theme: 'grey'
};

var Table = function Table(_ref) {
  var _classNames;

  var align = _ref.align,
      border = _ref.border,
      children = _ref.children,
      className = _ref.className,
      fixed = _ref.fixed,
      hover = _ref.hover,
      justify = _ref.justify,
      noWrap = _ref.noWrap,
      stripe = _ref.stripe,
      rest = _objectWithoutProperties(_ref, ["align", "border", "children", "className", "fixed", "hover", "justify", "noWrap", "stripe"]);

  var classes = classNames('table', (_classNames = {}, _defineProperty(_classNames, "table--".concat(align), align), _defineProperty(_classNames, 'table--border', border), _defineProperty(_classNames, 'table--fixed', fixed), _defineProperty(_classNames, 'table--hover', hover), _defineProperty(_classNames, "table--".concat(justify), justify), _defineProperty(_classNames, 'table--no-wrap', noWrap), _defineProperty(_classNames, 'table--stripe', stripe), _classNames), className);
  return /*#__PURE__*/React__default.createElement("table", _extends({
    className: classes
  }, rest), children);
};

Table.displayName = "Table";
Table.propTypes = {
  align: PropTypes.oneOf(['top', 'middle', 'bottom']),
  border: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  fixed: PropTypes.bool,
  hover: PropTypes.bool,
  justify: PropTypes.oneOf(['left', 'center', 'right']),
  noWrap: PropTypes.bool,
  stripe: PropTypes.bool
};
Table.defaultProps = {
  align: 'top',
  justify: 'left'
};

var Textarea = function Textarea(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      validity = _ref.validity,
      rest = _objectWithoutProperties(_ref, ["appearance", "className", "validity"]);

  var classes = classNames('textarea', _defineProperty({}, "textarea--".concat(appearance), appearance), className);
  var validStates = {
    invalid: true,
    valid: false
  };
  return /*#__PURE__*/React__default.createElement("textarea", _extends({
    "aria-invalid": validStates[validity],
    className: classes
  }, rest));
};

Textarea.displayName = "Textarea";
Textarea.propTypes = {
  appearance: PropTypes.oneOf(['border', 'flat', 'shadow']),
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  validity: PropTypes.oneOf(['valid', 'invalid'])
};
Textarea.defaultProps = {
  appearance: 'border'
};

var TextInput = function TextInput(_ref) {
  var _classNames;

  var appearance = _ref.appearance,
      className = _ref.className,
      type = _ref.type,
      validity = _ref.validity,
      rest = _objectWithoutProperties(_ref, ["appearance", "className", "type", "validity"]);

  var classes = classNames('text-input', (_classNames = {}, _defineProperty(_classNames, "text-input--".concat(appearance), appearance), _defineProperty(_classNames, "text-input--".concat(type), type), _classNames), className);
  var validStates = {
    invalid: true,
    valid: false
  };
  return /*#__PURE__*/React__default.createElement("input", _extends({
    "aria-invalid": validStates[validity],
    className: classes,
    type: type
  }, rest));
};

TextInput.displayName = "TextInput";
TextInput.propTypes = {
  appearance: PropTypes.oneOf(['border', 'flat', 'shadow']),
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  validity: PropTypes.oneOf(['valid', 'invalid'])
};
TextInput.defaultProps = {
  appearance: 'border',
  type: 'text'
};

var Toolbar = function Toolbar(_ref) {
  var _classNames;

  var align = _ref.align,
      appearance = _ref.appearance,
      children = _ref.children,
      className = _ref.className,
      outline = _ref.outline,
      pull = _ref.pull,
      rest = _objectWithoutProperties(_ref, ["align", "appearance", "children", "className", "outline", "pull"]);

  var containerClasses = classNames('toolbar-container', (_classNames = {}, _defineProperty(_classNames, "toolbar-container--".concat(appearance), appearance), _defineProperty(_classNames, "toolbar-container--".concat(outline), outline), _defineProperty(_classNames, "toolbar-container--pull-".concat(pull), pull), _classNames), className);
  var classes = classNames('toolbar', _defineProperty({}, "toolbar--".concat(align), align));
  return /*#__PURE__*/React__default.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React__default.createElement("ul", _extends({
    className: classes
  }, rest), children));
};

Toolbar.displayName = "Toolbar";
Toolbar.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right', 'spread']),
  appearance: PropTypes.oneOf(['border', 'shadow']),
  children: PropTypes.node,
  className: PropTypes.string,

  /** Deprecated */
  outline: PropTypes.oneOf(['border', 'shadow']),
  pull: PropTypes.oneOf(['up', 'down'])
};
Toolbar.defaultProps = {
  align: 'left',
  appearance: 'shadow',
  outline: 'shadow' // Deprecated

};

var ToolbarItem = function ToolbarItem(_ref) {
  var _classNames;

  var align = _ref.align,
      Tag = _ref.as,
      children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      Icon = _ref.icon,
      split = _ref.split,
      theme = _ref.theme,
      to = _ref.to,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["align", "as", "children", "className", "href", "icon", "split", "theme", "to", "type"]);

  var itemClasses = classNames('toolbar__item', {
    'toolbar__item--split': split
  });
  var toolClasses = classNames('toolbar__tool', (_classNames = {}, _defineProperty(_classNames, "toolbar__tool--".concat(align), align), _defineProperty(_classNames, "toolbar__tool--".concat(theme), theme), _classNames), className);
  return /*#__PURE__*/React__default.createElement("li", {
    className: itemClasses
  }, /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: toolClasses,
    to: to,
    href: href,
    type: Tag === 'button' ? type : null
  }, rest), Icon && /*#__PURE__*/React__default.createElement("span", {
    className: "toolbar__tool-icon"
  }, /*#__PURE__*/React__default.createElement(Icon, null)), React__default.Children.toArray(children).map(function (child, index) {
    if (typeof child === 'string') {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "toolbar__tool-text",
        key: index
      }, child);
    }

    if (child.type && child.type.displayName && child.type.displayName.includes('Icon') && React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "toolbar__tool-icon",
        key: index
      }, child);
    }

    if (child.type && child.type.displayName && child.type.displayName === 'Badge' && React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "toolbar__tool-badge",
        key: index
      }, child);
    }

    return child;
  })));
};

ToolbarItem.displayName = "ToolbarItem";
ToolbarItem.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.oneOf(['button', 'a'])]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  split: PropTypes.bool,
  theme: PropTypes.oneOf(['blue', 'green', 'grey', 'red']),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
};
ToolbarItem.defaultProps = {
  as: 'button',
  align: 'center',
  theme: 'green',
  type: 'button'
};

var Wrapper = function Wrapper(_ref) {
  var _classNames;

  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      gutters = _ref.gutters,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["align", "children", "className", "gutters", "width"]);

  var classes = classNames('wrapper', (_classNames = {}, _defineProperty(_classNames, "wrapper--".concat(align), align), _defineProperty(_classNames, "wrapper--gutters-".concat(gutters), gutters), _defineProperty(_classNames, "wrapper--width-".concat(width), width), _classNames), className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, rest), children);
};

Wrapper.displayName = "Wrapper";
Wrapper.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.node,
  className: PropTypes.string,
  gutters: PropTypes.oneOf(['none', 'S', 'M', 'L']),
  width: PropTypes.oneOf(['600', '800', '1000', '1200', '1540'])
};
Wrapper.defaultProps = {
  align: 'center',
  gutters: 'L',
  width: '1540'
};

exports.Avatar = Avatar;
exports.Badge = Badge;
exports.Banner = Banner;
exports.Blockquote = Blockquote;
exports.Box = Box;
exports.Breadcrumb = Breadcrumb;
exports.BreadcrumbItem = BreadcrumbItem;
exports.Button = Button;
exports.ButtonSignIn = ButtonSignIn;
exports.Checkbox = Checkbox;
exports.CheckboxGroup = CheckboxGroup;
exports.Code = Code;
exports.DescriptionList = DescriptionList;
exports.DescriptionTerm = DescriptionTerm;
exports.DescriptionDetails = DescriptionDetails;
exports.Details = Details;
exports.Fieldset = Fieldset;
exports.Grid = Grid;
exports.GridCell = GridCell;
exports.Header = Header;
exports.Heading = Heading;
exports.Hr = Hr;
exports.Indicator = Indicator;
exports.Label = Label;
exports.LabelCaption = LabelCaption;
exports.List = List;
exports.ListItem = ListItem;
exports.Loader = Loader;
exports.LogoGoogle = LogoGoogle;
exports.LogoSoftIron = LogoSoftIron;
exports.MediaWrap = MediaWrap;
exports.NavigationPrimary = NavigationPrimary;
exports.NavigationProgress = NavigationProgress;
exports.OffCanvasWrap = OffCanvasWrap;
exports.Overflow = Overflow;
exports.Paragraph = Paragraph;
exports.Pre = Pre;
exports.Progress = Progress;
exports.Radio = Radio;
exports.Range = Range;
exports.Section = Section;
exports.Select = Select;
exports.Site = Site;
exports.SiteFooter = SiteFooter;
exports.SiteHeader = SiteHeader;
exports.SiteMain = SiteMain;
exports.Status = Status;
exports.Table = Table;
exports.Textarea = Textarea;
exports.TextInput = TextInput;
exports.Toolbar = Toolbar;
exports.ToolbarItem = ToolbarItem;
exports.Wrapper = Wrapper;
